<template>
  <Submenu :name="`${parentName}`">
    <template slot="title">
      <i :class="parentItem[$config.router.iconKey]|| ''"></i>
      <span>{{ showTitle(parentItem) }}</span>
    </template>
    <template v-for="item in children">
      <template v-if="item.children && item.children.length === 1">
        <side-menu-item v-if="showChildren(item) && item[$config.router.isMenuKey]" :key="`menu-${item[$config.router.idKey]}`" :parent-item="item"></side-menu-item>
        <menu-item v-if="!showChildren(item) && item[$config.router.isMenuKey]" :name="item[$config.router.urlKey]" :to="item[$config.router.urlKey]" :key="`menu-${item[$config.router.idKey]}`"><i :class="item[$config.router.childrenKey][0][$config.router.iconKey] || ''"></i><span>{{ showTitle(item[$config.router.childrenKey][0]) }}</span></menu-item>
      </template>
      <template v-else>
        <side-menu-item v-if="showChildren(item) && item[$config.router.isMenuKey]" :key="`menu-${item[$config.router.idKey]}`" :parent-item="item"></side-menu-item>
        <menu-item v-if="!showChildren(item) && item[$config.router.isMenuKey]" :name="item[$config.router.urlKey]" :to="item[$config.router.urlKey]" :key="`menu-${item[$config.router.idKey]}`"><i :class="item[$config.router.iconKey]|| ''"></i><span>{{ showTitle(item) }}</span></menu-item>
      </template>
    </template>
  </Submenu>
</template>
<script>
import mixin from './mixin'
import itemMixin from './item-mixin'
export default {
  name: 'SideMenuItem',
  mixins: [ mixin, itemMixin ]
}
</script>



// WEBPACK FOOTER //
// src/view/main/components/side-menu/side-menu-item.vue